import createMuiTheme from '@material-ui/core/styles/createTheme';
export default function createTheme(options) {
    return createMuiTheme(Object.assign(Object.assign({}, options), { typography: Object.assign({}, options.typography) }));
}
//# sourceMappingURL=createTheme.js.map